const debugAccountEmails = {
  aang: 'aang@heylogin.dev',
  sokka: 'sokka@heylogin.dev',
  katara: 'katara@heylogin.dev',
  toph: 'toph@heylogin.dev',
  zuko: 'zuko@heylogin.dev',
  suki: 'suki@heylogin.dev',
  bumi: 'bumi@heylogin.dev',
  momo: 'momo@heylogin.dev',
  cabbages: 'cabbages@heylogin.dev',
  flopsie: 'flopsie@heylogin.dev',

  // names from https://www.notion.so/heylogin/4a8cdcad05c140ef987997c0e3279b85?v=018eeb8b35a547f0b3dbc34a471ed01c&p=f1d3d21be51545ce96ccd09669726a11&pm=c
  marie: 'marie@example.com',
  michael: 'michael@example.com',
  linda: 'linda@example.com',
  simon: 'simon@example.com',
  anne: 'anna@example.com',
  paul: 'paul@example.com',
  charlotte: 'charlotte@example.com',
} as const;

export default debugAccountEmails;
